import { useQuery } from "react-query"
import { get_jobs_js } from "../../services/jobs";


const useJobsJS = (page, filters, js_name, sort_by) => {

    return useQuery(['get_jobs_js', page, filters, js_name, sort_by], ()=>get_jobs_js(page, filters, js_name, sort_by))
}

export default useJobsJS;